// extracted by mini-css-extract-plugin
export default {"textRecordBlock":"TextRecordBlock_textRecordBlock__YiPuI"};